// @flow
import findLast from 'lodash/findLast';

type Deployment = {
  version: string
}

// Increments the provided version number to the next version number
// in X.X.X format, where each section is from 1 to 99
export const incrementVersion = (version) => {
  let [major, minor, patch] = version.split('.').map(i => parseInt(i, 10));

  if (patch < 99) {
    patch = patch + 1;
  } else {
    patch = 1;

    if (minor < 99) {
      minor = minor + 1;
    } else {
      minor = 1;
      major = major + 1;
    }
  }

  return [major, minor, patch].join('.');
};

// Gets the next version number based on active deployment, scheduled deployment,
// and deployment history versions
export default function getNextVersion(
  activeDeployment: Deployment,
  scheduledDeployment: Array<Deployment>,
  deploymentHistory: Array<Deployment>
) {
  let version = '';

  // Nothing has ever been deployed (the history has loaded and is empty): the first deployment is 1.0.0.
  // Without this, a new environment could never deploy: the button waits for a version forever.
  if (!activeDeployment && Array.isArray(deploymentHistory) && deploymentHistory.length === 0 && Array.isArray(scheduledDeployment)) {
    version = '1.0.0';
    while (findLast(scheduledDeployment, d => d.version === version)) {
      version = incrementVersion(version);
    }
    return version;
  }

  if (activeDeployment && deploymentHistory && scheduledDeployment) {
    const { version: activeVersion } = activeDeployment;

    version = incrementVersion(activeVersion);
    const compareVersions = d => d.version === version;

    while (findLast(deploymentHistory, compareVersions) ||
      findLast(scheduledDeployment, compareVersions)) {
      version = incrementVersion(version);
    }
  }

  return version;
}
